import { connect } from 'react-redux';
import ClientsPageComponent from '../components/ClientsPageComponent';
import { getClientsDataIfNeeded } from '../actions/clientsActions';

const mapStateToProps = (state) => ({
    clientsData: state.clients.clientsData,
    allLocations: state.clients.allLocations,
    isLoadingClientsData: state.clients.isLoadingClientsData,
});
const mapDispatchToProps = (dispatch) => ({
    getClientsDataIfNeeded: () => {
        dispatch(getClientsDataIfNeeded());
    },
});
const ClientsPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ClientsPageComponent);

export default ClientsPageContainer;
